import heatingType from './heating-type';

const options = [
  // Центральное газовое
  'centralGas',
  // Центральное угольное
  'centralCoal',
  // Печь
  'stove',
  // Камин
  'fireplace',
  // Электрическое
  'electric',
  // Автономное газовое
  'autonomousGas',
  // Дизельное
  'diesel',
  // Твердотопливный котел
  'solidFuelBoiler',
  // Без отопления
  'no',
];

export default options.map((type) =>
  heatingType.find((item) => item.key === type)
);
